(ns common.db.effects.cookie
  (:require [common.cookies :as cookies]
            [re-frame.core :as rf]))

(rf/reg-fx :cookie/set
  (fn [[k content & {:as params}]]
    (cookies/set-cookie! k content params)))

(rf/reg-fx :cookie/remove
  (fn [[k path domain]]
    (cookies/remove! k path domain)))
